export const UNASSIGNED_ID = '__UNASSIGNED_ID__';
export const INVITE_PEOPLE_ID = '__INVITE_PEOPLE_ID__';
export const AUTOMATIC_ID = '-1';
